// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8664) return "static/chunks/8664.48d5fc9f01f0d709.js";
	if (chunkId === 5637) return "static/chunks/5637.683e894c83cc71d8.js";
	if (chunkId === 4708) return "static/chunks/4708.7056aa300fc56cde.js";
	if (chunkId === 6195) return "static/chunks/6195.9106c5b8cae53188.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"225":"94d1904a67e432f0","887":"10f39aee7bc045b0","1095":"69de2240217caf0e","2568":"b9dde8be7afbdd65","3709":"a2df38b444aed67f","5732":"515dff705b258c09","7654":"d963b0f6f42933cf","8499":"4036b5088cfa74b3"}[chunkId] + ".js";
};